// App-Wide Constants
export const APP_NAME = 'Lightning Decoder';
export const APP_TAGLINE = 'Decode Lightning Network Requests';
export const APP_SUBTAGLINE = 'BOLT11, LNURL, and Lightning Address'
export const APP_INPUT_PLACEHOLDER = 'Enter Invoice';
export const APP_GITHUB = 'https://github.com/j-chimienti/lightning-decoder';
